import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import SalesOrderTabs from "./SalesOrderTabs";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import PrintReportMenu from "../common/PrintReportMenu";
const SalesOrderSearchResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a6";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const [selectedRecord, setSelectedRecord] = useState(null);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
        setSelectedRecord(selectedRowData);
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single"  />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="shippingdate" dataType="date" format="MM/dd/yyyy" caption='Ship Date' ></Column>
                <Column dataField="identityID" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Customer Name' ></Column>
                <Column dataField="transactiontype" caption='Transaction type' ></Column>
                <Column dataField="consignee" caption='Consignee' ></Column>
                <Column dataField="transactiondate" dataType="date" format="MM/dd/yyyy" caption='Order Date' ></Column>
                <Column dataField="transactionnumber" caption='Transaction.#' ></Column>
                <Column dataField="balanceDue" caption='BalanceDue' ></Column>
                <Column dataField="stage" caption='Stage' ></Column>
                <Column dataField="state" caption='State' ></Column>
                <Column dataField="address1" caption='Address- 1' ></Column>
                <Column dataField="itemTotal" caption='ItemTotal' ></Column>
                <Column dataField="transactionduedate" visible={false} caption='Transaction duedate'></Column>
                <Column dataField="purchaseordernumber" visible={false} caption='PO.#'></Column>
                <Column dataField="pricelevel" visible={false} caption='Pricelevel'></Column>
                <Column dataField="discounttype" visible={false} caption='Discount type'></Column>
                <Column dataField="discountpercent" visible={false} caption='DiscountPercent'></Column>
                <Column dataField="consigneeName" visible={false} caption='Consignee Name'></Column>
                <Column dataField="consigneeAddress1" visible={false} caption='ConsigneeAddress1'></Column>
                <Column dataField="consigneeAddress2" visible={false} caption='ConsigneeAddress2'></Column>
                <Column dataField="consigneeCity" visible={false} caption='ConsigneeCity'></Column>
                <Column dataField="consigneeZip" visible={false} caption='ConsigneeZip'></Column>
                <Column dataField="consigneeState" visible={false} caption='ConsigneeState'></Column>

                <Toolbar>
                <Item location="before">
                    <Button  text="Add" type="default"/>
                    </Item>
                    <Item location="before">
                    <PrintReportMenu selectedRecord={selectedRecord} />
                    </Item>
                    <Item location="before">
                    <Button className="gridTopButton"  text="Options" type="default"/>
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <SalesOrderTabs ref={childRef} accessToken={accessToken} />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SalesOrderSearchResult);